<template>
  <div class="video" :class="{'fixed': fixed, 'no-video': !hasVideo, my, speaking: isSpeaking && !fixed}">
    <slot />
    <div class="name">
      <span>{{ name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JanusRoomParticipantVideo',
  props: {
    name: {
      type: String,
      required: true,
    },
    fixed: Boolean,
    hasVideo: Boolean,
    my: Boolean,
    isSpeaking: Boolean,
  },
};
</script>

<style lang="scss" scoped>
video {
  display: block;
  max-width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  max-height: 6.5rem;
}

.no-video {
  width: 11.125rem;
  height: 100%;
}

.video {
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.5rem;
  overflow: hidden;
  transition: border-color 0.2s;
}

.fixed {
  border: 2px solid #0A82D9;
  box-shadow: 0 0 0 1px rgba(10, 130, 217, 0.3);
}

.speaking {
  border-color: #34C759;
  box-shadow: 0 0 0 2px rgba(52, 199, 89, 0.25);
}

.name {
  display: inline-block;
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 1.1;
  color: #FFFFFF;
  text-align: left;
  position: absolute;
  bottom: 0.25rem;
  left: 0.375rem;
  span {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border-radius: 3px;
    padding: 1px 5px;
  }
}

@media (max-width: 1199px) {
  video {
    max-height: 7.5rem;
  }
  .video {
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
  .fixed {
    border: 1.5px solid #0A82D9;
  }
  .no-video {
    width: 12.625rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    &.my {
      border: none;
    }
  }
  .name {
    left: 0.25rem;
  }
}

@media (max-width: 959px) {
  .video {
    height: auto;
  }
  video {
    height: auto;
  }
}

@media only screen and (orientation: landscape) and (max-width: 1199px) {
  video {
    max-width: 100%;
    height: auto;
    max-height: 6.5rem;
  }
  .no-video {
    border: none;
  }
}
</style>
